import { serviceMaker, methods, api } from "@/http/index.js";

export const getServices = () =>
  serviceMaker(`/servicemasters`, methods.GET, api.NGB);
export const getProducts = () => serviceMaker(`/product`, methods.GET, api.NGB);
// export const getServiceTypeData = () =>
//   serviceMaker(`/service/ServiceMasterView`, methods.GET, api.NGB);
export const getServiceTemplate = () =>
  serviceMaker(`/servicemasters/template`, methods.GET, api.NGB);
export const saveService = (data) =>
  serviceMaker(`/servicemasters`, methods.POST, api.NGB, data);
export const getServiceWithTemplate = (id) =>
  serviceMaker(`/servicemasters/${id}?template=true`, methods.GET, api.NGB);
export const editService = (id, data) =>
  serviceMaker(`/servicemasters/${id}`, methods.PUT, api.NGB, data);
export const getProductTemplate = () =>
  serviceMaker(`/product/template`, methods.GET, api.NGB);
// export const getServiceArray = (id) =>
//   serviceMaker(`/product/${id}/P`, methods.GET, api.NGB);
export const saveProducts = (data) =>
  serviceMaker(`/product`, methods.POST, api.NGB, data);
export const getProductWithTemplate = (id) =>
  serviceMaker(`/product/${id}?template=true`, methods.GET, api.NGB);
export const editProduct = (id, data) =>
  serviceMaker(`/product/${id}`, methods.PUT, api.NGB, data);
export const getservicemasters = (id) =>
  serviceMaker(`/servicemasters/${id}`, methods.GET, api.NGB);
export const getproduct = (id) =>
  serviceMaker(`/product/${id}`, methods.GET, api.NGB);
export const deleteservicemasters = (id) =>
  serviceMaker(`/servicemasters/${id}`, methods.DELETE, api.NGB);
export const deleteproduct = (id) =>
  serviceMaker(`/product/${id}`, methods.DELETE, api.NGB);
export const getExternalProducts = () =>
  serviceMaker(`/extrnal/products`, methods.GET, api.NGB);
